export default "__VITE_ASSET__BAds4ozL__"